import React from "react";
import classnames from "classnames";
import CloseIcon from "./assets/cross.inline.svg";
import AlertLargeIcon from "./assets/alert-large.inline.svg";
import styles from "./NotificationBanner.module.scss";
import MicroCopy from "@unum/micro-copy";

type Props = {
  variant?: "alert";
  children: React.ReactNode;
  onDismissClick?: () => void;
};

const variantToIconMap: Record<Props["variant"], SVGImport> = {
  alert: AlertLargeIcon
};

const NotificationBanner = ({
  variant = "alert",
  onDismissClick,
  children
}: Props) => {
  const VariantIcon = variantToIconMap[variant];
  return (
    <div
      className={classnames(
        styles["NotificationBanner"],
        "notification-banner notification-banner--active"
      )}
    >
      <div className="spring">
        <div className="row">
          <div className="col-xs-12 col-sm-9 col-md-7">
            <div className="notification-banner__wrapper">
              <VariantIcon
                className={classnames(
                  styles["notification-icon"],
                  "notification-banner__alert-icon"
                )}
              />
              <p className="notification-banner__description">{children}</p>
            </div>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-2 col-md-offset-3">
            <div className="notification-banner__dismiss">
              <button
                type="button"
                onClick={onDismissClick}
                className={classnames(
                  styles["dismiss"],
                  "button",
                  "notification-banner__dismiss-button"
                )}
              >
                <MicroCopy path="banner.dismiss" />
                <CloseIcon className="notification-banner__cross-icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;
